export default __webpack_public_path__ + "d89065b8197470554223ca735798a1d0.svg";